import { CatalogInfo, CatalogType, DynamicCatalogInfo } from '@shared/models/shared-catalog.state';
import { SelectOption } from '@shared/components/multi-select/models';
import { SortingType } from '../../data/modules/catalog-data/components/ordering/models';
import { CatalogItemValue, ReqInfo } from '../../data/models/catalog';
import { NextToMeData } from '../../data/modules/catalog-items-data/models/catalog-item.service';
import { TemplateRef } from '@angular/core';

export type CatalogItemFieldsResponse = {
  response: CatalogInfo[];
} & ReqInfo;

export type DynamicCatalogItemFieldsResponse = {
  response: DynamicCatalogInfo[];
} & ReqInfo;

export type Stats = {
  numberDownloads: number;
  numberView: number;
  numberVotes: number;
  rating: number;
};

export enum ReleaseStatus {
  New = 0,
  Actual = 1,
  History = 3,
  PublicData = 2
}

export type CatalogResponseInfo = {
  idPublicCatalog: number;
  namePublicCatalog: string;
  namePublicCatalogEn: string;
  idOpenCategory: number;
  nameOpenCategory: string;
  nameOpenCategoryEn: string;
  nameOIV: string;
  nameOIVEn: string;
  idOIV: number;
  publicCatalogStatus: string;
  cluster: boolean;
  accessibility: boolean;
  idNumber: string;
  keyAccess: string;
  linkForum: string;
  typeDict: string;
  hasGeo: boolean;
  seasonId: number;
  season: 'null';
  isDynamic: boolean;
  validDate: string;
  iso: boolean;
  dataset: {
    id: number;
    stat: Stats;
    actualVersion: string;
    actualVersionNum: number;
    actualRelease: string;
    actualReleaseNum: number;
    countRows: number;
    history: {
      idPublicCatalog: number;
      lastVersion: string;
      lastRelease: string;
      lastVersionNum: number;
      lastReleaseNum: number;
    }[];
    firstPublication: string;
  };
};

export type CatalogResponse = {
  response: CatalogResponseInfo[];
  found: number;
};

export type DynamicCatalogResponseInfo = {
  idPublicCatalog: number;
  id: number;
  namePublicCatalog: string;
  idOpenCategory: number;
  nameOpenCategory: string;
  nameOIV: string;
  idOIV: number;
  publicCatalogStatus: string;
  cluster: boolean;
  accessibility: boolean;
  idNumber: string;
  keyAccess: string;
  image: string | null;
  iso: boolean;
  layerId: string;
  hasGeo: boolean;
  archive: boolean;
  linkForum: string;
  validDate: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  details_opod: {
    linkForum: string;
  };
  stat: Stats;
  firstPublication: string;
  isDynamic: boolean;
};

export type CatalogResponseDynamic = {
  response: DynamicCatalogResponseInfo[];
  found: number;
};

export type NewSetsAndPopularSetsInfo = {
  idPublicCatalog: number;
  namePublicCatalog: string;
  namePublicCatalogEn: string;
  idOpenCategory: string;
  nameOpenCategory: string;
  nameOpenCategoryEn: string;
  numberView: number;
  idDataset: number;
  linkToPublicCatalog: string;
  firstPublication: string;
  seasonId: number;
  imageCategory: string;
  isDynamic: number;
  rating: number;
  numberDownloads?: number;
};

export type NewSetsAndPopularSetsResponse = {
  foundNew: number;
  newSets?: NewSetsAndPopularSetsInfo[];
  foundPopular: 4;
  popularSets?: NewSetsAndPopularSetsInfo[];
};

export type SeasonsSetsResponse = {
  found: number;
  catalogs: NewSetsAndPopularSetsInfo[];
};

export type CatalogParams = {
  criteria?: string;
  idPublicCatalog?: number[];
  sorting?: SortingType;
  limit?: number;
  offset?: number;
  idDataset?: number;
  access?: string;
};
export type CatalogItemValueResponse = {
  response: any;
  total: number;
} & ReqInfo;

export type GeoData = {
  p1: {
    type: 'Point';
    coordinates: number[];
  };
};

export type GetValueFieldsParams = {
  id: number;
  limit?: number;
  offset?: number;
  paging?: boolean;
  geoData?: GeoData;
  criteria: string;
  columnSort?: string;
  epoch?: string;
  timestamp?: number;
};
export type CatalogItemsValues = {
  catalogId: number;
  datasetId: number;
  criteria: string;
  pageSize: number;
  pageIndex: number;
  isRecommendationData?: boolean;
  nextToMeData?: NextToMeData;
  catalogItems?: CatalogItemValue[];
  selectCatalogItem?: CatalogItemValue;
  criteriaChanged: boolean;
  epoch?: string;
  isDynamic?: boolean;
};
export type SelectOptionMobile = {
  name: string;
  type?: CatalogType;
  isNumber: boolean;
  isLink: boolean;
  isFile?: boolean;
  catalogId: number;
  calculationWidth: number;
  columnContent?: TemplateRef<any>;
} & SelectOption;

export enum StatusType {
  Success = 1,
  Error
}

export type ResponseCatalogDataSave = {
  status: StatusType;
  message: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention,camelcase
  detail_message: string;
};
export type ParamsCatalogRatingSave = {
  idOpenCatalog: number;
  idUser?: number;
  rating: number;
};

export type AfterAuthorizationOperation =
  | 'AddFavoriteItem'
  | 'AddNotification'
  | 'GetRecommendation'
  | 'NewRecommendedFavoriteToggleState'
  | 'GetUserApiKey'
  | 'InformationPlacement';

export type NameAndId = {
  name: string;
  id: number | string;
};

export type FileData = {
  extention: string;
  id: string;
  type: string;
  fileName: string;
  fileSize: number;
  linkedFiles: any[];
}
